import { render } from "./FullscreenExit.vue?vue&type=template&id=08e7f064"
import script from "./FullscreenExit.vue?vue&type=script&lang=js"
export * from "./FullscreenExit.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__